import { FC, ReactNode } from 'react';
import styles from './MenuItem.module.scss';
import Divider, { DividerProps } from '#components/divider/Divider';

type Props = {
  children: ReactNode;
  divider?: boolean;
  dividerTop?: boolean;
  dividerProps?: DividerProps;
  noPadding?: boolean;
};

const MenuItem: FC<Props> = ({
  children,
  divider: dividerBottom,
  dividerTop,
  dividerProps,
  noPadding,
}) => {
  return (
    <li className={noPadding ? styles.noPaddingHost : styles.host}>
      {dividerTop && <Divider {...dividerProps} classes={styles.divider} />}
      {children}
      {dividerBottom && <Divider {...dividerProps} classes={styles.divider} />}
    </li>
  );
};
export default MenuItem;
